import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export { DownloadForm };

function DownloadForm(props) {
    function handleDownload() {
        const url = `/api/classes/${props.classId}/scores/download`;
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    }

    return (
        <div>
            <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
                Tải bảng điểm
            </Button>
        </div>
    );
}
